import { CustomDateObject } from '../shared/types'

const getDateFromCustomDate = (customDate: CustomDateObject): Date | undefined => {
  if (customDate.year && customDate.month && customDate.day) {
    const date: Date = new Date()

    date.setFullYear(customDate.year)
    date.setMonth(customDate.month - 1)
    date.setDate(customDate.day)

    return date
  }
}

export default getDateFromCustomDate
